<template>
  <span
    class="jm-mr-2 jm-mb-1 jm-py-1 jm-px-2 tag jm-border-radius jm-uppercase"
    >{{ label }}</span
  >
</template>

<script>
export default {
  name: 'BaseTag',
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.tag {
  font-size: $font-size-s;
  border: 1px solid $primary;
  color: $primary;
}
</style>
